import { Action, createReducer, on } from "@ngrx/store";
import {
  TenantDataFormatDTO,
  TenantDTO
} from "src/app/models/Tenant/Tenant.model";
import * as TenantActionTypes from "../../actions/tenant/tenant.actions";

export interface TenantState {
  tenant: TenantDataFormatDTO;
  tenantConfig: TenantDTO;
  isLoading: boolean;
  error: Error;
}

export const initialState: TenantState = {
  tenant: null,
  tenantConfig: null,
  isLoading: false,
  error: null,
};

const tenantFuelReducer = createReducer(
  initialState,
  on(
    TenantActionTypes.getCurrentTenantFormatList,
    (state, { pageReq }) =>
      ({
        ...state,
        error: null,
        pageReq: pageReq,
        isLoading: true,
      } as TenantState)
  ),
  on(TenantActionTypes.loadCurrentTenantFormatList, (state, { response }) => {
    return {
      ...state,
      tenant: (response as any).result?.tenantDataFormat
        ? (response as any).result?.tenantDataFormat
        : undefined,
      tenantConfig: (response as any).result
        ? (response as any).result
        : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(TenantActionTypes.loadTenant, (state, { result }) => {
    return {
      ...state,
      tenant: result.tenantDataFormat ? result.tenantDataFormat : undefined,
      tenantConfig: result ? result : undefined,
      isLoading: false,
      error: null,
    };
  }),
  on(TenantActionTypes.updateTenant, (state) => {
    return {
      ...state,
      isLoading: true,
    };
  }),
  on(TenantActionTypes.setLoadingEndState, (state) => {
    return {
      ...state,
      isLoading: false,
    };
  })
);

export function reducer(state: TenantState | undefined, action: Action) {
  return tenantFuelReducer(state, action);
}
